var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Menu',{attrs:{"active-name":"1-2","width":"auto"}},[(!_vm.isCollapsed)?_c('menu-show',{ref:"menuShow",attrs:{"menuList":_vm.menuList}}):_vm._e(),_vm._v(" "),(_vm.isCollapsed)?_c('menu-hide',{attrs:{"menuList":_vm.menuList}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9752d732","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/siderMenu/siderMenu.vue
// module id = null
// module chunks = 